$(document).ready(function() {
    if (typeof window.commissionChangesGrid !== 'undefined') {
        $('#commission-changes-grid').kendoGrid({
            selectable: false, //'multiple,row',
            sortable: true,
            filterable: window.getKendoGridFilterableSettings(),
            pageable: true,
            pageable: {
                pageSize: 10
            },
            columns: [
                {
                    field: 'Status',
                    title: 'Status',
                    width: '125px'
                },
                {
                    field: 'AffiliateTitle',
                    title: 'Affiliate Title',
                    width: '250px'
                },
                {
                    field: 'CommissionBefore',
                    title: 'Reward Before',
                    width: '150px',
                    filterable: false
                },
                {
                    field: 'CommissionAfter',
                    title: 'Reward After',
                    width: '150px',
                    filterable: false
                },
                {
                    field: 'CommissionTypeBefore',
                    title: 'Type Before',
                    width: '125px'
                },
                {
                    field: 'CommissionTypeAfter',
                    title: 'Type After',
                    width: '125px'
                },
                {
                    filterable: false,
                    title: '',
                    width: '150px',
                    template:
                        ' <a href="/affiliate/editcommissionchange/${ID}" id="edit-commission-change-${ ID }" data-record-id="${ ID }" class="edit-btn">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.5 21l-6.5 2 2-6.5 12-12 4.5 4.5zM15 4.5l3.086-3.085c.' +
                        '778-.778 2.05-.778 2.828 0l1.672 1.671c.778.779.778 2.051 0 2.829l-3.086 3.085M17.25 6.75l-10.75 10.75M3 16.5l1 1h2.5v2.5l1 1M2 20l2 2M16.5 3l4.5 4.5" ' +
                        'stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/></svg></a>'
                }
            ],
            dataSource: window.commissionChangesGrid,
            filterMenuInit: function(filterElement) {
                var textFields = ['Status', 'AffiliateTitle', 'CommissionTypeBefore', 'CommissionTypeAfter'];
                window.initializeTextFilterForKendoGrid(filterElement, textFields);
            }
        });
    }
});
